/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPriorityListResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get available priority options
 */
export const getPriorityOptions = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetPriorityListResponseDto>(
      {url: `/priorities`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPriorityOptionsQueryKey = () => {
    return [`/priorities`] as const;
    }

    
export const getGetPriorityOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPriorityOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriorityOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriorityOptions>>> = ({ signal }) => getPriorityOptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriorityOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPriorityOptions>>>
export type GetPriorityOptionsQueryError = unknown


export function useGetPriorityOptions<TData = Awaited<ReturnType<typeof getPriorityOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriorityOptions>>,
          TError,
          Awaited<ReturnType<typeof getPriorityOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriorityOptions<TData = Awaited<ReturnType<typeof getPriorityOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriorityOptions>>,
          TError,
          Awaited<ReturnType<typeof getPriorityOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriorityOptions<TData = Awaited<ReturnType<typeof getPriorityOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available priority options
 */

export function useGetPriorityOptions<TData = Awaited<ReturnType<typeof getPriorityOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriorityOptions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriorityOptionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



